import { useEffect } from "react";

const SITE = "https://www.fleecetheregime.com";

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (content == null) {
    if (el && el.dataset.seoDynamic) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  el.dataset.seoDynamic = "1";
}

// Per-route SEO: swap document title + meta description + canonical + social preview
// tags on navigation. opts { image, type, jsonLd } keep og/twitter tags and Product
// structured data in sync when client-side navigation opens another product.
// (The static index.html keeps sitewide defaults for first paint/crawlers; canonicals
// are injected per-route so unrecognized URLs never carry the homepage canonical.)
export default function useSEO(title, description, noindex = false, canonicalPath = null, opts = {}) {
  const jsonLdStr = JSON.stringify(opts.jsonLd || null);
  const image = opts.image || null;
  const type = opts.type || null;
  useEffect(() => {
    if (title) document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    if (description) meta.setAttribute("content", description);
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", noindex ? "noindex, nofollow" : "index, follow");
    let canonical = document.querySelector('link[rel="canonical"]');
    if (noindex) {
      if (canonical) canonical.remove();
    } else if (canonicalPath) {
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.rel = "canonical";
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", SITE + canonicalPath);
    }
    // Social preview: follows whatever page/product is currently open.
    setMeta("property", "og:title", title || null);
    setMeta("property", "og:description", description || null);
    setMeta("property", "og:type", type || "website");
    setMeta("property", "og:url", !noindex && canonicalPath ? SITE + canonicalPath : null);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", title || null);
    setMeta("name", "twitter:description", description || null);
    setMeta("name", "twitter:image", image);
    // Product structured data: present only on product pages, rebuilt per product.
    let ld = document.getElementById("seo-jsonld");
    if (jsonLdStr && jsonLdStr !== "null") {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "seo-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = jsonLdStr;
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, noindex, canonicalPath, jsonLdStr, image, type]);
}
